module.exports = __webpack_public_path__ + "img/Image_logo_8.e0024206.jpg";